<template>
  <div class="filter pdtb12">
    <div class="flex align-center mgb12">
      <div>橱窗分类：</div>
      <div class="text-pointer text-orange">
        全部
      </div>
    </div>
    <div class="flex align-center">
      <div>最近上新：</div>
      <div
        v-for="item in dayOptions"
        :key="item.value"
        class="text-pointer mgr12"
        :class="filterParams.newPutTime === item.value ? 'text-orange' : ''"
        @click="chooseFilter(item)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';

export default {
  components: {
  },
  data() {
    return {
      filterParams: {
        newPutTime: null,
      },
      dayOptions: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '近7天',
          value: 7,
        },
        {
          label: '近30天',
          value: 30,
        },
      ]
    };
  },
  methods: {
    chooseFilter(item) {
      this.filterParams.newPutTime = item.value;
      this.$emit('search');
    },
    getFilterParams() {
      let result = {};
      if (this.filterParams.newPutTime) {
        result = {
          ...this.filterParams,
        };
      }
      return result;
    }
  },

}

</script>

<style lang='scss' scoped>
.filter {
  
}
</style>
